export default "__VITE_ASSET__BFGuxtEr__"